// extracted by mini-css-extract-plugin
export default {"tooltip":"dW-z","arrow":"eW-z"};